var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',[_c('v-col',[_c('Jumbotron'),_c('Technology'),_c('CorporateVideoSection'),_c('BlogSection'),_c('CompanyCultureSection'),_c('ContactSection')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }